















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { natService } from '@/services/NatService';
import { portsValidationService } from '@/services/PortsValidation';
import { publicIPAddressService } from '../network/public-ip-address/services/PublicIPAddressService';
import { mapState } from 'vuex';

@Component({
  props: ['netCard', 'virtualMachine'],
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class VirtualMachineNetworkNats extends Vue {
  workspaceId = 0;
  regionId = 0;
  virtualMachineId = 0;
  isAddingNewNatActive = false;
  nats: any = [];
  publicAddresses: any = [];
  ip_address = '';
  source_port = '';
  destination_port = '';
  protocol = 'tcp';
  public_ip_address_id = '';
  selectedNats = [];
  validation: boolean = false;
  portValidation: { isValid: boolean; sourcePort: string; destPort: string } = {
    isValid: true,
    sourcePort: 'valid',
    destPort: 'valid',
  };
  isRemoveModalShown = false;
  isLoading = false;

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.virtualMachineId = parseInt(this.$route.params.virtualMachineId, 10);
    publicIPAddressService.getPublicIPAddresses(this.workspaceId, this.regionId).then(data => {
      this.publicAddresses = data.public_ip_addresses.filter((ip: any) => ip.state === 'idle');
    });
    this.getNats();
  }
  @Watch('$store.state.nats.nats', { immediate: true, deep: true })
  onNatsChange() {
    if (this.$props.netCard.id) {
      this.nats = this.$store.getters['nats/getByNicId'](this.$props.netCard.id);
    }
  }
  onCloseRemoveModal() {
    this.isRemoveModalShown = false;
  }
  getNats() {
    if (!this.$props.netCard.id || !this.$props.netCard.id) {
      return;
    }
    this.$store.dispatch('nats/getAllNats').then(() => {
      this.nats = this.$store.getters['nats/getByNicId'](this.$props.netCard.id);
    });
  }
  createNewNat(nicId: string) {
    this.portValidation = portsValidationService.validatePorts(this.source_port, this.destination_port);
    if (!this.portValidation.isValid && this.protocol !== 'any') {
      this.validation = true;
      return;
    }
    if (!this.public_ip_address_id) {
      this.validation = true;
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    natService
      .createNat(this.workspaceId, this.regionId, {
        nic_id: nicId,
        public_ip_address_id: this.public_ip_address_id,
        protocol: this.protocol,
        source_port: this.source_port,
        destination_port: this.destination_port,
      })
      .then(() => {
        this.isLoading = false;
        this.isAddingNewNatActive = false;
        this.getNats();
        this.setDefaultValues();
      })
      .catch(err => {
        this.isLoading = false;
        if (err.status === 422) {
          this.validation = true;
          this.portValidation = {
            isValid: false,
            sourcePort: err.data.error.source_port ? 'conflict' : 'valid',
            destPort: err.data.error.destination_port ? 'conflict' : 'valid',
          };
        }
      });
  }
  removeSelectedNats() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    natService
      .bulkDeleteNats(this.workspaceId, this.regionId, this.selectedNats)
      .then(() => {
        this.isLoading = false;
        this.getNats();
        this.isRemoveModalShown = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  setDefaultValues() {
    this.source_port = '';
    this.destination_port = '';
    this.public_ip_address_id = '';
    this.protocol = 'tcp';
    this.isAddingNewNatActive = false;
    this.validation = false;
  }
}
